import { useCallback, useContext } from 'react';
import { useMutation } from '@apollo/client';
import classNames from 'classnames/bind';
import { ADD_PAYMENT_SOURCE } from '../../REGISTER_QUERIES_AND_MUTATIONS';
import PaymentSources from './PaymentSources';
import StripeForm from './StripeForm';
import { Checkbox } from '../../../../../components/fancyFieldsV2';
import { RegistrationContext } from '../../../../../contexts';
import { RegistrationActions } from '../../../../../contexts/RegistrationContext/RegistrationReducer';
import styles from '../../../../../styles/main.module.scss';
import { useAlertMessage } from '../../../../../hooks';

const { UPDATE_REGISTRATION_STATE } = RegistrationActions;

const cx = classNames.bind(styles);

const AddPaymentCard = () => {
  const { showSuccess, showError } = useAlertMessage();

  const [registerState, registerDispatch] = useContext(RegistrationContext);

  const { deletePaymentInfo, paymentSources } = registerState;

  const [addPaymentMutation] = useMutation(ADD_PAYMENT_SOURCE);

  const onTokenSuccess = useCallback(
    async ({ token }) => {
      try {
        await addPaymentMutation({
          variables: { input: { tokenId: token?.id } },
        });
        showSuccess('Successfully added payment method');
      } catch (error) {
        showError(error);
      }
    },
    [addPaymentMutation, showError, showSuccess]
  );

  return (
    <div>
      {!!paymentSources?.length &&
        paymentSources?.map(source => <PaymentSources key={source?.id} source={source} />)}
      <div className="d-flex justify-content-between align-content-center">
        <h3>Add a Card</h3>
        <div>
          <Checkbox
            className={cx('register-checkbox')}
            value={deletePaymentInfo}
            label="Don't save my card"
            onChange={val =>
              registerDispatch({
                update: { deletePaymentInfo: val },
                type: UPDATE_REGISTRATION_STATE,
              })
            }
          />
        </div>
      </div>
      <div className={cx('register-text-field', 'pt-3')}>
        <StripeForm onTokenSuccess={onTokenSuccess} />
      </div>
    </div>
  );
};

export default AddPaymentCard;
